import React from 'react';
import Header from './shared/Header';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
import { getRandomColor } from '../utils/colors';
const WinterPracticeWorkshopPage = () => {
  useRandomLinkColors();
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-675" data-mp="1hoc1zwkdg2e0">
      <Header data-id="element-676" data-mp="1cpinq1x9g7cs" />
      <main className="flex min-h-screen pt-24 px-6 pb-16" data-id="element-677" data-mp="1cr3gpn3xfi8j">
        {/* Mobile Layout */}
        <div className="md:hidden w-full max-w-2xl mx-auto" data-id="element-678" data-mp="p195tb3643qx">
          <h1 className="text-4xl font-bold mb-8 leading-tight" data-id="element-679" data-mp="k14rnrpqfl3v">
            The Winter Practice Workshop
          </h1>

          <div className="text-base mb-8" data-id="element-680" data-mp="yynm9ap3csj8">
            <div className="font-bold mb-2" data-id="element-681" data-mp="yzp01mxhrt4n">Dates:</div>
            <div data-id="element-682" data-mp="tz188z1fv89d">Starts 24th January, 2026</div>
            <div data-id="element-683" data-mp="u1don7rjtakb">Five Weeks, 3-Hours Per Week</div>
            <div className="mb-4" data-id="element-684" data-mp="2acreabc4c6ln">Saturday's from 9am - 12 pm EST</div>

            <div className="font-bold mb-2" data-id="element-685" data-mp="25eg2hv29jm0s">Location:</div>
            <div data-id="element-686" data-mp="25dy3iqo7utp6">All sessions will take place over Zoom.</div>
            <div className="mb-4" data-id="element-687" data-mp="2fx1k6sa8oh8">
              Class recordings and weekly assignments will be shared via email
              at the end of each week.
            </div>

            <div data-id="element-688" data-mp="cdbgu32gz77y">Workshop Fee: $375 USD</div>
            <div className="mb-4" data-id="element-689" data-mp="cemls67nil0n">Refunds up to 30 days before event.</div>

            <div className="mb-4" data-id="element-690" data-mp="gfeumycm2nwe">Workshop limited to 12 attendees.</div>

            <div className="text-base" data-id="element-691" data-mp="3fu0fl2vt9cn2">
              <span className="font-bold text-[#333333] line-through" data-id="element-692" data-mp="3fv32z0txcwy8">
                SOLD OUT
              </span>{' '}
              <span className="italic text-[#333333]" data-id="element-693" data-mp="3ktmpb2cfkar4">
                *
                <a href="mailto:mm@madeleinemorlet.com" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-694" data-mp="3otngzoojiig4">
                  email
                </a>{' '}
                for waitlist
              </span>
            </div>
          </div>

          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pbeQ5zz7K1Hno1NcmsjwBC/Madeleine-Morlet_10_copy_2.jpg" alt="Morning light through curtained windows" className="w-full h-auto mb-8" data-id="element-695" data-mp="3bapv3nphngb" />

          <div className="text-base leading-relaxed space-y-4 mb-8" data-id="element-696" data-mp="3lgnqerhhkytt">
            <div className="font-bold mb-2" data-id="element-697" data-mp="3lj0c9fqd7tc5">Workshop:</div>
            <p data-id="element-698" data-mp="3gjdy942pq92a">
              This winter workshop is designed to throw fresh logs on the fire
              of your creative practice during the year's most introspective
              months. Blending artistic process, habit-building, and group
              critique, the format draws inspiration from Julia Cameron's{' '}
              <em data-id="element-699" data-mp="19tpnefdkmata">The Artist's Way</em> and early methodologies of the Iowa
              Writers' Workshop (where students present their work for
              discussion without explanation, allowing them to 'see' it as
              others do). The aim is to help you establish a repeatable and
              generative rhythm that cycles between writing and
              photography—supporting the development of a daily creative routine
              or strengthening the one you already have.
            </p>
            <p data-id="element-700" data-mp="1w01uafaegi5o">
              Each session includes a lecture on a key theme, followed by a
              group critique. Participants are welcome to bring an existing
              project or begin something new, and will introduce their practices
              during the first week. Lectures will explore new entry points into
              photography through art, cinema, and literature, alongside
              carefully selected examples of images and writing that encourage
              awe, curiosity, and connection. Weekly assignments will consist of
              a short reading, a writing prompt, and a shooting task.
            </p>
            <p data-id="element-701" data-mp="w22phj0p2aeq">
              Where creative habits often lose momentum in the winter, this
              workshop offers structure, accountability, and the support of a
              thoughtful cohort. It is ideal for photographers of any ability or
              discipline who are interested in evolving their practices.
              Students can expect a busy and productive five weeks, engaging in
              writing and image-making that are both confidence-building and
              deeply satisfying. At the heart of the workshop is a spirit of
              playful inquiry, one that leaves participants with a renewed sense
              of purpose—ready to carry them into spring.
            </p>
          </div>

          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dcDGGrrwFtUCkeLK9Mn7qj/Madeleine-Morlet_Headshot.jpg" alt="Madeleine Morlet" className="w-32 h-auto mb-4" data-id="element-702" data-mp="100tppz0gi862" />

          <div className="text-base leading-relaxed" data-id="element-703" data-mp="2107qxhs8qb0y">
            <div className="font-bold mb-2" data-id="element-704" data-mp="211siqzn67fv4">Instructor:</div>
            <p data-id="element-705" data-mp="2519rq31t2v51">
              Madeleine Morlet is a British-American photographer based in
              London. Her teaching centers on the narrative potential of
              photography and the photobook form, informed by her background in
              filmmaking and creative writing. She combines editorial feedback
              with practical strategy to help students both refine their vision
              and sustain creative practices, guiding them toward publication.
              An award-winning photographer recognised by institutions including
              PhotoVogue and the Lucie Foundation, she brings both professional
              experience and artistic insight into the classroom.
            </p>
          </div>
        </div>

        {/* Desktop Layout */}
        <div className="hidden md:flex flex-row w-full max-w-6xl mx-auto gap-12" data-id="element-706" data-mp="37oen2dx6qpui">
          <div className="w-full md:w-1/2 flex flex-col gap-8" data-id="element-707" data-mp="37ma7gypxc2ee">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pbeQ5zz7K1Hno1NcmsjwBC/Madeleine-Morlet_10_copy_2.jpg" alt="Morning light through curtained windows" className="w-full h-auto" data-id="element-708" data-mp="2i10rtv371krp" />

            <div className="flex-1 flex flex-col justify-end" data-id="element-709" data-mp="2mzvitkbbefmw">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dcDGGrrwFtUCkeLK9Mn7qj/Madeleine-Morlet_Headshot.jpg" alt="Madeleine Morlet" className="w-32 h-auto mb-4" data-id="element-710" data-mp="2mxit2kzbf0za" />

              <div className="text-base leading-relaxed" data-id="element-711" data-mp="3appuvznt8063">
                <div className="font-bold mb-2" data-id="element-712" data-mp="3an3o428qtoox">Instructor:</div>
                <p data-id="element-713" data-mp="35remltd5xxpz">
                  Madeleine Morlet is a British-American photographer based in
                  London. Her teaching centers on the narrative potential of
                  photography and the photobook form, informed by her background
                  in filmmaking and creative writing. She combines editorial
                  feedback with practical strategy to help students both refine
                  their vision and sustain creative practices, guiding them
                  toward publication. An award-winning photographer recognised
                  by institutions including PhotoVogue and the Lucie Foundation,
                  she brings both professional experience and artistic insight
                  into the classroom.
                </p>
              </div>
            </div>
          </div>

          <div className="w-full md:w-1/2" data-id="element-714" data-mp="3886m8n9jz4wg">
            <div className="max-w-2xl" data-id="element-715" data-mp="2ubjrmr52oqtp">
              <h1 className="text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-716" data-mp="2ucl4901qlldj">
                The Winter Practice Workshop
              </h1>

              <div className="text-base mb-8" data-id="element-717" data-mp="sivki6pb5j8n">
                <div className="font-bold mb-2" data-id="element-718" data-mp="sk6kdvfmu6uh">Dates:</div>
                <div data-id="element-719" data-mp="xiqbea9328tp">Starts 24th January, 2026</div>
                <div data-id="element-720" data-mp="xgdr3qfurmdh">Five Weeks, 3-Hours Per Week</div>
                <div className="mb-4" data-id="element-721" data-mp="3gfyc89dwqjl1">Saturday's from 9am - 12 pm EST</div>

                <div className="font-bold mb-2" data-id="element-722" data-mp="3cew9hiks7peb">Location:</div>
                <div data-id="element-723" data-mp="3chir6b1dzla9">All sessions will take place over Zoom.</div>
                <div className="mb-4" data-id="element-724" data-mp="37nejfpkar984">
                  Class recordings and weekly assignments will be shared via
                  email at the end of each week.
                </div>

                <div data-id="element-725" data-mp="2xrkybhsii7eq">Workshop Fee: $375 USD</div>
                <div className="mb-4" data-id="element-726" data-mp="2xo5hoaj6wqb7">Refunds up to 30 days before event.</div>

                <div className="mb-4" data-id="element-727" data-mp="2sq3y7ohuqoz7">Workshop limited to 12 attendees.</div>

                <div className="text-base" data-id="element-728" data-mp="2oqmsqv2fdru1">
                  <span className="font-bold text-[#333333] line-through" data-id="element-729" data-mp="2oroepukzbyqj">
                    SOLD OUT
                  </span>{' '}
                  <span className="italic text-[#333333]" data-id="element-730" data-mp="myqhlmk66jzs">
                    *
                    <a href="mailto:mm@madeleinemorlet.com" className="transition-colors duration-200" onMouseEnter={e => {
                    e.currentTarget.style.color = getRandomColor();
                  }} onMouseLeave={e => {
                    e.currentTarget.style.color = '#333333';
                  }} data-id="element-731" data-mp="hzncy383qfsc">
                      email
                    </a>{' '}
                    for waitlist
                  </span>
                </div>
              </div>

              <div className="text-base leading-relaxed space-y-4" data-id="element-732" data-mp="bivjwckp2yzt">
                <div className="font-bold mb-2" data-id="element-733" data-mp="bl81gomjj7cc">Workshop:</div>
                <p data-id="element-734" data-mp="gh5kj2p6urst">
                  This winter workshop is designed to throw fresh logs on the
                  fire of your creative practice during the year's most
                  introspective months. Blending artistic process,
                  habit-building, and group critique, the format draws
                  inspiration from Julia Cameron's <em data-id="element-735" data-mp="1w0thdtt7vre0">The Artist's Way</em> and
                  early methodologies of the Iowa Writers' Workshop (where
                  students present their work for discussion without
                  explanation, allowing them to 'see' it as others do). The aim
                  is to help you establish a repeatable and generative rhythm
                  that cycles between writing and photography—supporting the
                  development of a daily creative routine or strengthening the
                  one you already have.
                </p>
                <p data-id="element-736" data-mp="1we5evrch1e9b">
                  Each session includes a lecture on a key theme, followed by a
                  group critique. Participants are welcome to bring an existing
                  project or begin something new, and will introduce their
                  practices during the first week. Lectures will explore new
                  entry points into photography through art, cinema, and
                  literature, alongside carefully selected examples of images
                  and writing that encourage awe, curiosity, and connection.
                  Weekly assignments will consist of a short reading, a writing
                  prompt, and a shooting task.
                </p>
                <p data-id="element-737" data-mp="wbz9m2chvzy2">
                  Where creative habits often lose momentum in the winter, this
                  workshop offers structure, accountability, and the support of
                  a thoughtful cohort. It is ideal for photographers of any
                  ability or discipline who are interested in evolving their
                  practices. Students can expect a busy and productive five
                  weeks, engaging in writing and image-making that are both
                  confidence-building and deeply satisfying. At the heart of the
                  workshop is a spirit of playful inquiry, one that leaves
                  participants with a renewed sense of purpose—ready to carry
                  them into spring.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default WinterPracticeWorkshopPage;